import {
    GET_PERMISSIONS_LIST_SUCCESS,
    GET_PERMISSIONS_LIST_FAIL,
    ADD_NEW_PERMISSION_SUCCESS,
    ADD_NEW_PERMISSION_FAIL,
    UPDATE_PERMISSION_SUCCESS,
    UPDATE_PERMISSION_FAIL,
    DELETE_PERMISSION_SUCCESS,
    DELETE_PERMISSION_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    permissions: [],
    error: {},
}

const Permissions = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_PERMISSIONS_LIST_SUCCESS:
            return {
                ...state,
                permissions: action.payload,
            }

        case GET_PERMISSIONS_LIST_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_NEW_PERMISSION_SUCCESS:
            return {
                ...state,
                permissions: [...state.permissions, action.payload],
            }

        case ADD_NEW_PERMISSION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_PERMISSION_SUCCESS:
            return {
                ...state,
                permissions: state.permissions.map(p =>
                    p.id.toString() === action.payload.id.toString() ? action.payload : p
                ),
            }

        case UPDATE_PERMISSION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_PERMISSION_SUCCESS:
            return {
                ...state,
                permissions: state.permissions.filter(
                    p => p.id.toString() !== action.payload.toString()
                ),
            }

        case DELETE_PERMISSION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default Permissions
